const setEnvs = {};
const setEnvDefault = (key, val) => {
  if (!process.env[key]) {
    process.env[key] = val;
  }
  setEnvs[key] = process.env[key];
};

setEnvDefault('DEBUG', false);
setEnvDefault('PORT', 8080);
setEnvDefault('TOGA_SERVER_PORT', 8080);
setEnvDefault('TOGA_SERVER_HOST', '0.0.0.0');
setEnvDefault('TOGA_SOURCE', 'production');
setEnvDefault('TOGA_BASE_URL_SEARCH', 'suggestedsearch.service.c.prod-eu-west-1.noths.com');

// old ansible env variables
setEnvDefault('TOGA_ENVIRONMENT', "production");
setEnvDefault('TOGA_AWS_BUCKET', "noths-prod-eu-west-1-c-noths-frontend");
setEnvDefault('TOGA_AWS_REGION', "eu-west-1");
setEnvDefault('TOGA_ASSETS_HOST', "cdn.notonthehighstreet.com");
setEnvDefault('TOGA_BASE_URL_STOREFRONT', "http://partner-content.service.c.prod-eu-west-1.noths.com/delivery");

module.exports = setEnvs;



// WEBPACK FOOTER //
// ./src/config/index.js